import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";

// Components
import AppBar from "../../../components/AppBar";
import UserTable from "../../../components/tables/Users";
import BreadcrumbsTitle from "../../../components/title/Breadcrumbs";
import TableTitle from "../../../components/title/Table";

// Material Icons
import { PeopleAltOutlined } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";
import SecondCard from "../../../components/cards/SecondCard";
import { useAuth } from "../../../hooks/auth";

export default function UserList() {
  const { APIClient } = useAuth();
  const [data, setData] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isError, setIsError] = React.useState(false);
  const { msg } = useParams();

  React.useEffect(() => {
    if (!isError) {
      APIClient.get("/admin/alluser")
      .then((res) => {
        setData(res.data)
        setIsLoading(false)
    })
      .catch((err) => setIsError(true))
    }
  }, [APIClient, isError, msg]); // Empty dependency array ensures data is fetched only once

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar title="User List" />
      <Box
        component="main"
        sx={{
          backgroundColor: "fafafa",
          flexGrow: 1,
          overflow: "auto",
          paddingBottom: 10,
          height: "calc(100vh - 3px);",
          boxSizing: "border-box",
        }}
      >
        <Toolbar />
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          <BreadcrumbsTitle text="User List" />
          <SecondCard
            avatar={
              <PeopleAltOutlined
                sx={{ width: 25, height: 25 }}
                color="primary"
              />
            }
            total={data.length.toLocaleString()}
            subtitle={"Total Pengguna TKN"}
          />
          <Card
            sx={{
              boxShadow:
                "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset;",
              p: 4,
              mt: 2,
              borderRadius: 2,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <TableTitle
                  text="User List"
                  action="/user-list/add"
                  isAction={true}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                {isError ? "Error": null}
                {
                  isLoading ? <CircularProgress/> : 
                  <UserTable data={data} />
                }
              </Grid>
            </Grid>
          </Card>
        </Container>
      </Box>
    </Box>
  );
}
